import {ProceduresItemType} from 'domain/usecases/private/my-hospitalization/get-procedures-list';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {useDebounceSearch} from 'presentation/hooks/useDebounceSearch';
import {useGetPaginatedItemsReactQuery} from 'presentation/pages/private/hooks/useGetPaginatedItemsReactQuery';
import {getProceduresList} from '../services/getProceduresList';

const SIZE = 6;

export const useProcedures = () => {
	const {searchValueState, debouncedQueryFunc, clearSearchParams, abortDebounce} =
		useDebounceSearch({});

	const {
		items,
		loadingItemsList,
		itemsListIsEmpty,
		itemsListHasError,
		totalItems,
		loadMore,
		resetState,
		refresh,
		isLoading,
	} = useGetPaginatedItemsReactQuery<ProceduresItemType>({
		queryKey: [QUERY_KEYS.HOSPITALIZATION_PROCEDURES_LIST, searchValueState],
		queryFn: ({page}) =>
			getProceduresList({
				'procedure-name': searchValueState.toUpperCase(),
				page,
				size: SIZE,
			}),
	});

	return {
		items,
		loadingItemsList,
		isLoading,
		itemsListIsEmpty,
		itemsListHasError,
		totalItems,
		loadMore,
		resetState,
		refresh,
		searchValueState,
		debouncedQueryFunc,
		clearSearchParams,
		abortDebounce,
	};
};
